import * as React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    skiplink: {
        position: "absolute",
        opacity: 0,
        "&:focus": {
            position: "relative",
            opacity: 1,
        },
    },
}));

const SkipLink: React.FC = () => {
    const styles = useStyles();
    return (
        <a
            href="#skip-destination"
            aria-label="Skip to main content"
            className={styles.skiplink}
            style={{ fontSize: "20px" }}
        >
            Skip to main content
        </a>
    );
};

export default SkipLink;
